/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 8.5L8.5 3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.5 3.5H8.5V8.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowTopRight = (props) => <Icon component={svg} className="arrow-top-right" {...props} />;

export default ArrowTopRight;
